import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { PATH_COSTS, PATH_COSTS_NEW } from '../../app/constants/paths.constant';
import { CostForm } from '../../forms/Cost';
import { FormVariant } from '../../forms';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewCostPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Costs);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'un Coût")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_COSTS,
            label: 'coûts',
            key: 'costs',
          },
          {
            to: PATH_COSTS_NEW,
            label: 'nouveau',
            key: 'newCost',
          },
        ]}
      />
      <PageTitle title="Création d'un Coût" />
      <CostForm formVariant={FormVariant.Creation} showCancelButton={false} />
    </>
  );
};
